// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/antd.min.css
// module id = 2281
// module chunks = 0